<template>
  <div class="austrian-post-guide">
    <p>
      After adding the pass, please open the Wallet app on your smartphone. You
      will find your saved passport there.
    </p>
    <p>
      Select the appropriate passport and press the symbol
      <span style="font-weight: bold;">ⓘ</span>
      to see your benefits or to change your preferences.
    </p>
    <div id="mobile-info" @click="handleClick">
      <AndroidWalletButton />
    </div>

    <p>
      If you do not yet use a wallet app, we will direct you to the free
      download in the Google Play Store. Your digital The voucher pass will then
      be added directly.
    </p>
  </div>
</template>

<script>
import AndroidWalletButton from "@/components/AndroidWalletButton.vue";

export default {
  components: {
    AndroidWalletButton
  },
  methods: {
    handleClick() {
      const pk = `${process.env.VUE_APP_YOURPASS_GET}/${this.$route.params.id}?format=pkpass`;
      const url =
        pk.replace(/^(https?:)/, "intent:") +
        "#Intent;scheme=yourwallet;package=eu.yourpass.wallet;S.market_referrer=" +
        pk +
        ";end";
      this.$store.commit("loading", true);
      var pl = document.createElement("a");
      pl.href = pk;

      // fake a click on the link
      var me = document.createEvent("MouseEvents");
      me.initEvent("click", true, true);
      pl.dispatchEvent(me);

      setTimeout(() => {
        this.$store.commit("loading", false);
      }, 2000);
    }
  }
};
</script>
<style scoped>
#mobile-info {
  text-align: center;
}

#yourwallet-btn {
  font-size: 22px;
  font-weight: 400;
  position: relative;
  display: inline-block;
  margin: 20px 0 5px 0;
  padding: 10px 24px;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  color: #333;
  border-radius: 5px;
  background-color: #f8b51d;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
}

#yourwallet-btn > svg {
  width: 40px;
  height: 40px;
  margin: 0 10px 0 -8px;
  vertical-align: middle;
  fill: currentColor;
  float: left;
}

#yourwallet-btn > span {
  display: inline-block;
  vertical-align: middle;
}

#yourwallet-btn.black {
  font-size: 20px;
  font-weight: 300;
  height: 46px;
  padding: 6px 18px;
  border: 1px solid #000;
  border-radius: 15px;
  background: transparent;
  margin-bottom: 15px;
  color: white;
  border: 1px solid #a6a6a6;
  background-color: #000;
}
</style>
